import AcxSelect from "components/UI/Select/BaseSelectComponents/AcxSelect";
import ClassifierCategory from "models/ClassifierCategoryId";
import React, { useCallback, useState } from "react";
import ClassifierService from "services/ClassifierService";

type CategorySelectorProps = Partial<
    Omit<React.ComponentPropsWithoutRef<typeof AcxSelect>, "options">
>;

export function CategorySelector(props: CategorySelectorProps) {
    const [options, setOptions] = useState<ClassifierCategory[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchOptions = useCallback(async () => {
        if (isLoading || options.length > 0) return;

        try {
            setIsLoading(true);
            const service = new ClassifierService();
            const categories = await service.getClassifierCategories();
            setOptions(categories);
        } finally {
            setIsLoading(false);
        }
    }, [isLoading, options]);

    return (
        <AcxSelect
            id="category"
            valueField="name"
            labelField="name"
            enableNoSelection
            fullWidth
            {...props}
            isLoading={isLoading}
            options={options}
            onMenuOpen={fetchOptions}
        />
    );
}
